import React from 'react';
import '../../styles/index/HomePage.css';
import Footer from '../layout/Footer';

const HomePage = () => {

    return (
        <div className="homepage-container">
            <header className="hero-section">
                <div className="hero-content">
                    <div className="hero-text-content">
                        <h1 className="hero-title">Secure your communications</h1>
                        <p className="hero-subtitle">
                            We provide modern solutions to protect your confidential data
                        </p>
                    </div>
                </div>
            </header>
            
            <Footer />
        </div>
    );
};

export default HomePage;